var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70313 9.275C6.88646 9.09167 7.11979 9 7.40312 9C7.68646 9 7.91979 9.09167 8.10313 9.275L12.0031 13.175L15.9031 9.275C16.0865 9.09167 16.3198 9 16.6031 9C16.8865 9 17.1198 9.09167 17.3031 9.275C17.4865 9.45833 17.5781 9.69167 17.5781 9.975C17.5781 10.2583 17.4865 10.4917 17.3031 10.675L12.7031 15.275C12.6031 15.375 12.4948 15.446 12.3781 15.488C12.2615 15.5293 12.1365 15.55 12.0031 15.55C11.8698 15.55 11.7448 15.5293 11.6281 15.488C11.5115 15.446 11.4031 15.375 11.3031 15.275L6.70313 10.675C6.51979 10.4917 6.42812 10.2583 6.42812 9.975C6.42812 9.69167 6.51979 9.45833 6.70313 9.275Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.ecaa3b4bbfdabab70bd57b7e2c778007.svg";
export { ForwardRef as ReactComponent };